import { render } from "./entity_config_detail.html?vue&type=template&id=053ed835&external"
import script from "./entity_config_detail.js?vue&type=script&lang=js&external"
export * from "./entity_config_detail.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__